module.exports = __webpack_public_path__ + "static/media/logo.340b6413.svg";